import { render, staticRenderFns } from "./LocalLoader.vue?vue&type=template&id=3a18ab85&lang=true&"
import script from "./LocalLoader.vue?vue&type=script&lang=js&"
export * from "./LocalLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports